import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUser } from '../contexts/userContext';

interface PrivateRouteProps {
  children: React.ReactNode;
  redirect?: string;
}

const PrivateRoute = ({ children, redirect }: PrivateRouteProps) => {
  const { state: { isLoggedIn } } = useUser();
  const location = useLocation();

  if (!isLoggedIn) {
    const returnUrl = redirect || location.pathname;
    return <Navigate to={`/signin?returnUrl=${encodeURIComponent(returnUrl)}`} replace />;
  }

  return <>{children}</>;
};

export { PrivateRoute };
